<template>
  <ul class="Sidebar pt-3 pr-3 pb-3 flex-shrink-0" :class="{ opened: value }">
    <span
      class="toggler"
      :class="{ toggled: value }"
      @click.stop="$emit('input', !value)"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 48 48"
      >
        <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)">
          <g>
            <path
              d="M6.46.5,12.6,6.65a.48.48,0,0,1,0,.7L6.46,13.5"
              style="
                fill: none;
                stroke: #000000;
                stroke-linecap: round;
                stroke-linejoin: round;
              "
            ></path>
            <path
              d="M1.25.5,7.4,6.65a.5.5,0,0,1,0,.7L1.25,13.5"
              style="
                fill: none;
                stroke: #000000;
                stroke-linecap: round;
                stroke-linejoin: round;
              "
            ></path>
          </g>
        </g>
      </svg>
    </span>

    <li
      v-for="(item, index) in computedSteps"
      :key="item.id"
      :class="{
        active: item.active,
        error: errors.includes(index),
      }"
      class="d-flex align-items-center justify-content-between"
      @click="select(index)"
    >
      <span class="sidebar_rows">
        <div class="border-left">
          <span class="icon mr-2">
            <slot :name="`icon-${item.id}`"></slot>
          </span>

          <span class="name">
            {{ item.name }}
          </span>
        </div>
        <span v-if="errors.includes(index)" class="error-icon">
          <svg
            width="16"
            height="16"
            fill="none"
            stroke="var(--red)"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </span>
      </span>
    </li>

    <slot name="below-sections"></slot>
  </ul>
</template>

<script>
export default {
  props: {
    value: Boolean,
    steps: {
      type: Array,
      required: true,
    },
    errors: Array,
    activeStep: String,
  },
  methods: {
    select(index) {
      this.$emit("click-on-el");
      this.$emit("select", index);
    },
  },
  computed: {
    computedSteps() {
      const active = this.activeStep;

      return this.steps.map((item, index) => ({
        ...item,

        active: active === item.id,
      }));
    },
  },
};
</script>

<style>
@media (max-width: 640px) {
  .Sidebar {
    flex-basis: 30px;
    padding-left: 10px !important;
    padding-right: 7px !important;
    padding-top: 26px !important;
  }
}
</style>

<style scoped>
.Sidebar {
  position: relative;
  flex-basis: 210px;
  border-right: 1px solid var(--black-20);
  padding-top: 30px !important;
  margin: 0;
  background-color: #fbfbfb;
  min-width: 250px;
  padding-left: 30px;
}

li,
.icon {
  transition-duration: 0.1s;
}

li {
  position: relative;
  list-style: none;
  cursor: pointer;
  white-space: nowrap;
}

li + li {
  margin-top: 16px;
}

.icon {
  position: relative;
  transform: translateY(-1.5px);
  color: var(--black-20);
}

.line {
  position: absolute;
  width: 2px;
  height: 14px;
  left: 50%;
  top: 100%;
  margin-top: 5px;
  transform: translateX(-50%);
  border-radius: 1px;
  background-color: #d1d3d4;
}

li:hover {
  font-weight: 600;
}

.error,
.error .icon {
  color: var(--red) !important;
}

li:hover,
li.active,
li:hover .icon,
li.active .icon {
  color: var(--mint-green) !important;
  /* border-left: 1px solid #33c9d2 !important; */
}

.Sidebar,
.icon {
  color: #212529;
  font-weight: 600;
}

.icon svg {
  width: 16px;
  height: 16px;
}

.error-icon {
  display: block;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.toggler {
  display: none;
  transform: rotate(0deg);
  transition-duration: 0.15s;
}

.toggled {
  transform: rotate(180deg);
}

@media (max-width: 1270px) {
  .Sidebar {
    flex-basis: 175px;
  }
}

@media (max-width: 640px) {
  .Sidebar {
    transition-duration: 0.15s;
    /* position: absolute; */
    top: 0px;
    left: 0px;
    height: auto;
    width: 100%;
    padding-right: 0px !important;
    padding-top: 20px !important;
    /* padding: 0px !important; */
    z-index: 200;
    overflow: hidden;
    min-width: 0px;
    border-right: unset;
    border-bottom: 1px solid var(--black-20);
    transition: height 0.5s ease-in;
    flex-basis: unset;
  }

  .toggler {
    display: none;
  }

  .toggler.toggled {
    transform: rotate(270deg);
  }

  .border-left{
    border: unset !important;
  }
}

.dots {
  display: flex;
  grid-gap: 2px;
}

.dots_icon {
  background-color: black;
  height: 2px;
  width: 2px;
  display: block;
  border-radius: 50%;
}

.sidebar_rows {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.border-left {
  border-left: none !important;
}
</style>
